import { Grid, Skeleton, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<any>()((theme, props) => ({
	subtitle: {
		...props?.subtitle
	},
	content: {
		paddingTop: 3,
		paddingBottom: 3,
		lineBreak: 'anywhere',
		...props?.content
	}
}));

const DetailsGridRows = (props) => {
	const { data, gridSize, containerSpacing, customStyle, isLoading, subtitleVariant = 'h6', contentVariant = 'body1' } = props;
	const { classes } = useStyles(customStyle);

	const renderContents = () => {
		return (
			data &&
			data.map((item, index) => {
				const {
					subTitle,
					content,
					subtitleVariant: dataSubtitleVariant,
					subtitleClassName,
					contentVariant: dataContentVariant,
					contentClassName
				} = item;

				return (
					<Grid item xs={gridSize} key={`${subTitle}-${index}`}>
						<Typography variant={dataSubtitleVariant || subtitleVariant} className={subtitleClassName || classes.subtitle}>
							{isLoading ? <Skeleton /> : subTitle}
						</Typography>
						<Typography component="div" variant={dataContentVariant || contentVariant} className={contentClassName || classes.content}>
							{isLoading ? <Skeleton /> : content}
						</Typography>
					</Grid>
				);
			})
		);
	};

	return (
		<Grid container gap={containerSpacing || 5}>
			{renderContents()}
		</Grid>
	);
};

export default DetailsGridRows;
